import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef, MatDialogModule} from '@angular/material/dialog';
import {environment} from '../../../../environments/environment';
import {TranslateModule} from '@ngx-translate/core';
import {NgIf, NgStyle} from '@angular/common';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {ActivatedRoute, NavigationExtras, Router} from '@angular/router';
import {DialogWidth} from '@q9elements/ui-kit/common';
import {PrimaryButtonComponent} from '@q9elements/ui-kit/components';

@Component({
  selector: 'app-error-dialog',
  templateUrl: './error-dialog.component.html',
  styleUrls: ['./error-dialog.component.scss'],
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    NgIf,
    TranslateModule,
    NgStyle,
    PrimaryButtonComponent
  ]
})
export class ErrorDialogComponent implements OnInit {
  message;
  callback;
  additionalMessage;
  windowLocation;
  disableClose = false;
  dialogWidth = DialogWidth.SM;

  constructor(
    @Inject(MAT_DIALOG_DATA) private info,
    private dialogRef: MatDialogRef<ErrorDialogComponent>,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.additionalMessage = info.additionalMessage;
    this.message = info.message;
    this.disableClose = info.disableClose;
    this.callback = this[info.callback];
  }

  ngOnInit(): void {
    this.windowLocation = window.location.href;
  }

  navigateToDashboard() {
    window.open(environment.MAIN_APP_URL, '_self');
  }

  reloadToViewMode() {
    if (this.info.navWithoutReload) {
      const {edit, ...queryParams} = this.route.snapshot.queryParams;
      const extras = {
        queryParams,
        skipLocationChange: false
      } as NavigationExtras;

      return this.router.navigate([], extras);
    }

    window.location.href = this.windowLocation.replace('&edit=true', '');
  }

  reloadDiagram() {
    window.location.href = this.windowLocation;
  }

  closeApp() {
    window.close();
  }

  ok() {
    if (this.callback) {
      this.dialogRef.close(this.callback.bind(this));
    } else {
      this.dialogRef.close();
    }
  }
}
